export enum FormTypeEnum {
	dossier = 'dossier',
	customTextField = 'customTextField',
	nombreRecherche = 'nombreRecherche'
}